<main>
    <section class="well bg-color">
        <div class="container">
            <h3 class="center">{{"NAV.VESAKKOMURSKIMET" | translate}}</h3>
            <div class="row">
                <div class="grid_6"><img src="assets/images/hp_kameran_kuvat_12_6_2006-023-1.jpg" alt=""></div>
                <div class="grid_6 mg-add">
                    <h6>{{"VESAKKO.TITLE" | translate}}</h6>
                    <p class="txt1">
                        {{"VESAKKO.DESCRIPTION" | translate}}
                    </p>
                    <br/>
                    <p class="txt1">
                        {{"VESAKKO.DESCRIPTION2" | translate}}
                    </p>
                    <br/>
                    <h6>{{"VESAKKO.DESC2-TITLE" | translate}}</h6>
                    <ul style="list-style: inside; margin-left: 20px">
                        <li>{{"VESAKKO.DESC2.1" | translate}}</li>
                        <li>{{"VESAKKO.DESC2.2" | translate}}</li>
                        <li>{{"VESAKKO.DESC2.3" | translate}}</li>
                        <li>{{"VESAKKO.DESC2.4" | translate}}</li>
                        <li>{{"VESAKKO.DESC2.5" | translate}}</li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
    <section class="well center">
        <div class="container">
            <h3>{{"TOTEUTUKSIA" | translate}}</h3>
            <div class="row off1">
                <div class="grid_4"><a class="img"><img class=" square-image-home"
                                                                 src="assets/images/P4450TLN-NH-TS115A-024-800x600.png"
                                                                 alt=""><span></span></a>
                </div>
                <div class="grid_4"><a class="img"><img class=" square-image-home"
                                                                 src="assets/images/photo-1-copy-19.jpg"
                                                                 alt=""><span></span></a>
                </div>
                <div class="grid_4"><a class="img"><img class=" square-image-home"
                                                                 src="assets/images/K180-kelamurskain--768x512.jpg"
                                                                 alt=""><span></span></a>
                </div>
            </div>
            <div class="row off1">
                <div class="grid_4"><a class="img"><img class=" square-image-home"
                                                                 src="assets/images/oivanen-3-800-x-600-1-768x576.jpg"
                                                                 alt=""><span></span></a>
                </div>
                <div class="grid_4"><a class="img"><img class=" square-image-home"
                                                                 src="assets/images/Murska.JPG"
                                                                 alt=""><span></span></a>
                </div>
                <div class="grid_4"><a class="img"><img class=" square-image-home"
                                                                 src="assets/images/P4450TLN-2-400x300-300x225.jpg"
                                                                 alt=""><span></span></a>
                </div>
            </div>
        </div>
    </section>
    <section class="well bg-color" style="display: flex">
        <div class="container">
            <div style="display: flex; justify-content: center; flex-direction: column; overflow: auto;height: 35vh;">
                <h3>{{"SPECIFICATIONS" | translate}}</h3>
                <br/>
                <table class="data-table">
                    <tbody>
                    <tr>
                        <td></td>
                        <td>K160</td>
                        <td>K180</td>
                        <td>H1600/J</td>
                        <td>H2100/J</td>
                    </tr>
                    <tr>
                        <td>{{"VESAKKO.WORKWIDTH" | translate}} (m)</td>
                        <td>1,65</td>
                        <td>1,85</td>
                        <td>1,65</td>
                        <td>2,15</td>
                    </tr>
                    <tr>
                        <td>{{"WEIGHT" | translate}} (kg)</td>
                        <td>265</td>
                        <td>290</td>
                        <td>430</td>
                        <td>530</td>
                    </tr>
                    <tr>
                        <td>{{"VESAKKO.AMOUNT" | translate}} (kpl)</td>
                        <td>72</td>
                        <td>80</td>
                        <td>72</td>
                        <td>96</td>
                    </tr>
                    <tr>
                        <td>{{"BLADETYPE" | translate}}</td>
                        <td>{{"VESAKKO.SHACKLE" | translate}}+<br>{{"VESAKKO.LIGHTBLADE" | translate}}</td>
                        <td>{{"VESAKKO.SHACKLE" | translate}}+<br>{{"VESAKKO.LIGHTBLADE" | translate}}</td>
                        <td>{{"VESAKKO.STURDYBLADE" | translate}}</td>
                        <td>{{"VESAKKO.STURDYBLADE" | translate}}</td>
                    </tr>
                    <tr>
                        <td>{{"USECASE" | translate}}</td>
                        <td>{{"VESAKKO.HAYLAWN" | translate}}</td>
                        <td>{{"VESAKKO.HAYLAWN" | translate}}</td>
                        <td>{{"VESAKKO.SOCKETUPTO50MM" | translate}}</td>
                        <td>{{"VESAKKO.SOCKETUPTO50MM" | translate}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </section>
    <section>
        <div>
            <iframe style="width: 100%; height: 60vh" src="https://www.youtube.com/embed/v2haaDjh4BY?controls=0"
                    frameborder="0" allowfullscreen></iframe>
        </div>
    </section>
</main>
